import apiClient from './apiClient';

class PostClient {
    getPosts = ({ page, tagId, limit = 20 }) =>
        apiClient.get(`/forum/post?page=${page}&limit=${limit}&sort=time&tagId=${tagId}`);

    // 按讚、取消按讚貼文
    likePost = ({ postId }) => apiClient.post(`/social/post/${postId}/like`);

    // 取得當期話題
    getCurrentTopics = ({ page = 1, limit = 4 }) =>
        apiClient.get(`/forum/topic?isCurrent=1&page=${page}&limit=${limit}`);
}

const postClient = new PostClient();

export default postClient;
